<template>
    <section ref="appMain" class="app-main">
        <transition name="fade-transform" mode="out-in">
            <keep-alive :include="cachedViews">
                <router-view />
            </keep-alive>
        </transition>
    </section>
</template>

<script>
export default {
    name: "AppMain",
    created() {
        this.setRouteId(this.$route);
        this.judegAdmin();
    },
    computed: {
        cachedViews() {
            return this.$store.getters.cachedViews;
        },
        key() {
            return this.$route.path;
        }
    },
    methods: {
        judegAdmin() {
            if(this.$route.meta.belong == "admin") {
                this.$store.dispatch("SetAdmnMenu", "admin");
            }else {
                this.$store.dispatch("SetAdmnMenu", "undefined");
            }
        },
        setRouteId(to) {
            if(this.$route.meta.modules) {
                this.$store.dispatch("SetRouterId", to.meta.modules[0]);
            }
        }
    },
    watch: {
        $route(to, from) {
            this.$refs.appMain.scrollTop = 0;
            this.setRouteId(to);
            this.judegAdmin();
        }
    }
};
</script>

<style lang="scss" scoped>
.app-main {
    position: relative;
    min-height: 100vh;
    overflow-x: hidden;
}

.fixed-header + .app-main {
    padding-top: 50px;
}

.hasTagsView {
    .app-main {
        /* 84 = navbar + tags-view = 50 + 34 */
        min-height: calc(100vh - 84px);
    }

    .fixed-header + .app-main {
        padding-top: 84px;
    }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
    .fixed-header.is-have-scroll {
        padding-right: 10px;
    }
}
</style>
